<template>
  <div class="crc">
    <div class="boss" style="width: 90%;float: right;">
      <div class="Statistics">
        <ul>
          <li>数量统计</li>
          <li>
            <img src="../assets/crcbjt.png" class="imgg" />
            <span class="span">CRC总数</span>
            <span class="span1">{{count}}个</span>
          </li>
          <li>
            <img src="../assets/dsh.png" class="imgg" />
            <span class="spa">待审核</span>
            <span class="spa1">{{notCount}}个</span>
          </li>
          <li>
            <img src="../assets/ysh.png" class="imgg" />
            <span class="spa">已审核</span>
            <span class="spa1">{{yesCount}}个</span>
          </li>
        </ul>
      </div>
      <div class="bbt">
        <a
          class="s-bt"
          @click="selected()"
          :class="{active: active == 1}"
          style="margin-left: 40px;"
        >待审核</a>
        <a class="s-bt sss" @click="selected1()" :class="{active: active == 2}">已审核</a>
      </div>
      <div class="tab" v-show="dai">
        <el-table
          :data="tableData"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          ref="table"
          align="left"
          :header-cell-style="{background:'#D0EAFF',color:'#333333',fontFamily:'MicrosoftYaHeiUI',fontSize:'16px',fontWeight:400}"
        >
          <el-table-column prop="cnName" label="姓名" align="center" width="120px"></el-table-column>
          <el-table-column prop="sex" label="性别" align="center" width="100px"></el-table-column>
          <el-table-column prop="province" label="区域" align="center"></el-table-column>
          <el-table-column prop="idCard" label="身份证号码" align="center" width="170px"></el-table-column>
          <el-table-column prop="idCardImgFront" label="身份证人像面" align="center">
            <template slot-scope="scope">
              <el-popover placement="top" title trigger="click">
                <img :src="imgurl+zimggs" class="imht1" />
                <img slot="reference" :src="imgurl+zimggs" :alt="imgurl+zimggs" class="imht" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="idCardImgBack" label="身份证国徽面" align="center">
            <template slot-scope="scope">
              <el-popover placement="top" title trigger="click">
                <img :src="imgurl+fimgs" class="imht1" />
                <img slot="reference" :src="imgurl+fimgs" :alt="imgurl+fimgs" class="imht" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="workImgUrl" label="免冠一寸白底照片" align="center">
            <template slot-scope="scope">
              <el-popover placement="top" title trigger="click">
                <img :src="imgurl+mian" class="imht1" />
                <img slot="reference" :src="imgurl+mian" :alt="imgurl+mian" class="imht" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="handheldPhoto" label="手持身份证半身照" align="center">
            <template slot-scope="scope">
              <el-popover placement="top" title trigger="click">
                <img :src="imgurl+shouci" class="imht1" />
                <img slot="reference" :src="imgurl+shouci" :alt="imgurl+shouci" class="imht" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="注册手机号" align="center"></el-table-column>
          <el-table-column prop="createTime" label="注册时间" align="center"></el-table-column>
          <!--<el-table-column
				      prop="auditRemark"
				      label="备注"
				      align="center">
          </el-table-column>-->
          <!--<el-table-column
				      prop="state"
				      label="审核"
				      align="center">
				      	<template slot-scope="scope">
					      	<button @click="btn1(scope.row.userId)" style="width:60px;height:28px;border:none;cursor:pointer;background:rgba(0,153,68,1);border-radius:2px;line-height: 28px;font-size:14px;font-weight:400;color:rgba(255,255,255,1);">通过</button>
					      	<button @click="btn2(scope.row.userId)" style="width:60px;height:28px;border:none;cursor:pointer;background:rgba(239,67,67,1);border-radius:2px;line-height: 28px;font-size:14px;font-weight:400;color:rgba(255,255,255,1);">不通过</button>
				    	</template>
          </el-table-column>-->
        </el-table>
        <div class="Page">
          <div class="PageMain center" style="display: flex;justify-content: center;">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="pageNum"
              layout="total, prev, pager, next, jumper"
              :total="totalNum"
            ></el-pagination>
            <!--<el-button type="primary" class="PageBtn" v-on:click="handleCurrentChange">确定</el-button>-->
          </div>
        </div>
      </div>
      <div class="tab" v-show="yi">
        <el-table
          :data="tableData1"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          ref="table"
          align="left"
          :header-cell-style="{background:'#D0EAFF',color:'#333333',fontFamily:'MicrosoftYaHeiUI',fontSize:'16px',fontWeight:400}"
        >
          <el-table-column prop="cnName" label="姓名" align="center" width="120px"></el-table-column>
          <el-table-column prop="sex" label="性别" align="center" width="100px"></el-table-column>
          <el-table-column prop="province" label="区域" align="center"></el-table-column>
          <el-table-column prop="idCard" label="身份证号码" align="center" width="170px"></el-table-column>
          <el-table-column prop="idCardImgFront" label="身份证人像面" align="center">
            <template slot-scope="scope">
              <el-popover placement="top" title trigger="click">
                <img :src="imgurl + scope.row.idCardImgFront" class="imht1" />
                <img slot="reference" :src="imgurl + scope.row.idCardImgFront"  class="imht" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="idCardImgBack" label="身份证国徽面" align="center">
            <template slot-scope="scope">
              <el-popover placement="top" title trigger="click">
                <img :src="imgurl + scope.row.idCardImgBack" class="imht1" />
                <img slot="reference" :src="imgurl + scope.row.idCardImgBack"  class="imht" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="workImgUrl" label="免冠一寸白底照片" align="center">
            <template slot-scope="scope">
              <el-popover placement="top" title trigger="click">
                <img :src="imgurl + scope.row.workImgUrl" class="imht1" />
                <img slot="reference" :src="imgurl + scope.row.workImgUrl"  class="imht" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="handheldPhoto" label="手持身份证半身照" align="center">
            <template slot-scope="scope">
              <el-popover placement="top" title trigger="click">
                <img :src="imgurl + scope.row.handheldPhoto" class="imht1" />
                <img slot="reference" :src="imgurl + scope.row.handheldPhoto" class="imht" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="注册手机号" align="center"></el-table-column>
          <el-table-column prop="createTime" label="注册时间" align="center"></el-table-column>
          <el-table-column prop="auditRemark" label="查看" align="center">
            <template slot-scope="scope">
              <img
                src="../assets/chakan.png"
                @click="chaKan(scope.row.userId)"
                style="width: 40px;height: 40px;cursor: pointer;"
              />
            </template>
          </el-table-column>
          <!--<el-table-column
				      prop="state"
				      label="审核结果"
				      align="center">
				      	<template slot-scope="scope">
					       	<div :style="scope.row.state === '通过'?'color:#009944':'color:#EF4343'">
					       		{{ scope.row.state }}
					       	</div>
				        </template>
          </el-table-column>-->
        </el-table>
        <div class="Page">
          <div class="PageMain center" style="display: flex;justify-content: center;">
            <el-pagination
              background
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="pageNum"
              layout="total, prev, pager, next, jumper"
              :total="totalNum1"
            ></el-pagination>
            <!--<el-button type="primary" class="PageBtn" v-on:click="handleCurrentChange">确定</el-button>-->
          </div>
        </div>
      </div>
    </div>
    <div class="preview-modal" v-if="peviewstatus">
      <Preview @peviewstatus="closePeview" :childid="childid"></Preview>
    </div>
    <router-view />
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { crcgetData } from "@/request/api";
import { crcgetDatatongji } from "@/request/api";
import Preview from "../components/preview";
export default {
  name: "company",
  data() {
    return {
      childid: "",
      peviewstatus: false,
      active: "",
      tableData: [],
      imgurl: this.Common.imgurl,
      dai: true,
      yi: false,
      currentPage: 1,
      pageNum: 20,
      totalCount: 0,
      totalNum: "",
      totalNum1: "",
      currentPage1: 1,
      tableData: [],
      tableData1: [],
      count: 0,
      notCount: 0,
      yesCount: 0,
      id: [],
      fimgs: "",
      zimggs: "",
      mian: "",
      shouci: "",
      fimgs1: "",
      zimggs1: "",
      mian1: "",
      shouci1: "",
      status: 2
    };
  },
  mounted() {
    this.getData();
    this.getData1();
    this.selected1();
  },
  components: {
    Preview: Preview
  },
  methods: {
    chaKan(id) {
      this.childid = id;
      this.peviewstatus = true;
    },
    closePeview(data) {
      this.peviewstatus = data;
    },
    selected() {
      this.active = 1;
      this.getData();
      this.dai = true;
      this.yi = false;
    },
    selected1() {
      this.active = 2;
      this.yi = true;
      this.dai = false;
      let data = {
        pageSize: this.pageNum,
        pageIndex: this.currentPage
      };
      crcgetData(data)
        .then(res => {
          console.log(res);
          this.tableData1 = res.data.data;
          console.log("终极无敌测试dabug~this.tableData1", this.tableData1);
          this.totalNum1 = res.data.totalRows;
          var arr1 = res.data.data;
          console.log(arr1);
          for (var i = 0; i < arr1.length; i++) {
            console.log(arr1[i].state);
            if (arr1[i].sex == "1") {
              arr1[i].sex = "男";
            } else if (arr1[i].sex == "2") {
              arr1[i].sex = "女";
            }
            if (arr1[i].state == "2") {
              arr1[i].state = "通过";
            } else if (arr1[i].state == "3") {
              arr1[i].state = "不通过";
            }
            this.zimggs1 = arr1[i].idCardImgFront;
            this.fimgs1 = arr1[i].idCardImgBack;
            this.mian1 = arr1[i].workImgUrl;
            this.shouci1 = arr1[i].handheldPhoto;
          }
        })
        .catch(err => {});
    },
    btn1() {},
    btn2() {},
    getData() {
      //			let data = {
      //				pageSize: this.pageNum,
      //				pageIndex: this.currentPage,
      //			};
      //			crcgetData(data)
      //			.then((res)=>{
      //				console.log(res)
      //				this.tableData = res.data.data;
      //				this.totalNum = res.data.totalRows;
      //				var arr = res.data.data;
      //				console.log(arr);
      //				for(var i=0; i<arr.length; i++){
      //					if(arr[i].sex == "1"){
      //						arr[i].sex = "男"
      //					}else if(arr[i].sex == "2"){
      //						arr[i].sex = "女"
      //					}
      //					this.zimggs = arr[i].idCardImgFront;
      //					this.fimgs = arr[i].idCardImgBack;
      //					this.mian = arr[i].workImgUrl;
      //					this.shouci = arr[i].handheldPhoto;
      //				}
      //			}).catch((err)=>{
      //
      //			})
    },
    getData1() {
      let token = Cookies.get("token");
      console.log(token);
      let data = {
        //				pageIndex: this.pageNum,
        //				pageSize: this.currentPage,
      };
      crcgetDatatongji(data)
        .then(res => {
          console.log(res.data.data);
          this.count = res.data.data.count;
          this.notCount = res.data.data.notCount;
          this.yesCount = res.data.data.yesCount;

          //					console.log(this.count);
          //					if(res.data.code == "000000") {
          //					}
        })
        .catch(err => {
          console.log(err);
        });
    },
    tabRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleSizeChange(val) {
      this.pageNum = val;
      console.log(this.pageNum);
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(this.currentPage);
      this.getData();
    },
    handleSizeChange1(val) {
      this.pageNum = val;
      console.log(this.pageNum);
      this.selected1();
    },
    handleCurrentChange1(val) {
      this.currentPage = val;
      console.log(this.currentPage1);
      this.selected1();
    }
  }
};
</script>

<style scoped>
.imht {
  width: 130px;
  height: 60px;
}
.imht1 {
  width: 800px;
  height: 500px;
}
.ss {
  display: block;
  float: left;
  /*margin-left:50px;*/
  cursor: pointer;
  height: 60px;
  color: rgba(54, 114, 191, 1);
  border-bottom: 2px solid rgba(54, 114, 191, 1);
  font-size: 16px;
  font-weight: bold;
}
.ss1 {
  margin-left: 50px;
  cursor: pointer;
}
.s-bt {
  display: block;
  float: left;
  margin-left: 8px;
  cursor: pointer;
}
.sss {
  margin-left: 50px;
}
.active {
  height: 60px;
  color: rgba(54, 114, 191, 1);
  border-bottom: 2px solid rgba(54, 114, 191, 1);
  font-size: 16px;
  font-weight: bold;
}
.el-table .warning-row {
  background: #f6fbff;
}
.Statistics {
  widows: 80%;
  height: 140px;
  background: rgba(255, 255, 255, 1);
}
ul li {
  display: flex;
  float: left;
  line-height: 140px;
  font-size: 16px;
  font-weight: bold;
  padding-left: 40px;
  /*padding-right: 50px;*/
  color: rgba(54, 114, 191, 1);
}
ul li + li {
  width: 210px;
  height: 140px;
  /*float: left;*/
  margin-left: 50px;
  line-height: 140px;
}
.span {
  position: absolute;
  /*left: -190px;*/
  top: 55px;
  font-size: 16px;
  padding-left: 20px;
  font-weight: 400;
  color: rgba(245, 245, 245, 1);
}
.span1 {
  position: absolute;
  /*left: -260px;*/
  top: 100px;
  font-size: 24px;
  padding-left: 20px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}
.spa {
  position: absolute;
  /*left: -190px;*/
  top: 55px;
  font-size: 16px;
  padding-left: 20px;
  font-weight: 400;
  color: rgba(245, 245, 245, 1);
}
.spa1 {
  position: absolute;
  /*left: -240px;*/
  top: 100px;
  font-size: 24px;
  padding-left: 20px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}
.imgg {
  width: 205px;
  height: 109px;
  /*line-height: 150px;*/
  /*margin-top: 20px;*/
  position: relative;
  top: 18px;
}
.bbt {
  width: 100%;
  height: 60px;
  float: left;
  line-height: 60px;
  margin-top: 15px;
  margin-bottom: 20px;
  background: rgba(255, 255, 255, 1);
  /*background: #EEF2F6;*/
  border-radius: 4px;
}
.Page {
  margin-top: 20px;
}
.el-pagination {
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/administrators/crcaudit.vue